<!-- MOLECULE: DrawerToggle.vue -->

<script setup lang="ts">
//
// Model
//
const drawer = defineModel<boolean>();

//
// Composables
//

// Drawer
const { drawerRailMode, toggleDrawer } = useDrawer();

// Localization
const { t } = useI18n();

//
// Computed Properties
//
const tooltipText = computed(() => {
  if (!drawer.value) {
    return t("components.common.app-bar.drawer_toggle.open_tooltip");
  }

  if (drawerRailMode.value) {
    return t("components.common.app-bar.drawer_toggle.rail_tooltip");
  }

  return t("components.common.app-bar.drawer_toggle.close_tooltip");
});
</script>

<template>
  <v-tooltip location="bottom" :open-delay="700" :close-delay="300">
    <template #activator="{ props: attrs }">
      <v-app-bar-nav-icon v-bind="attrs" color="primary" @click="toggleDrawer" />
    </template>

    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>
